module.exports = __webpack_public_path__ + "static/img/hotPicks.78129b7d.png";